module.exports = __webpack_public_path__ + "static/img/exercise-5.0266e78.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-5.png
// module id = pJCw
// module chunks = 1